import {ReactNode} from 'react';
import {cn} from '../lib/utils';

interface NavLinkCaptionProps {
    children?: ReactNode;
    className?: string;
}

export const NavLinkCaption = ({children, className, ...props}: NavLinkCaptionProps) => {
    const navLinkStyles = cn('text-[#F2F4F7] font-[500] text-[1rem] md:text-[0.875rem]', className);
    return (
        <span {...props} className={navLinkStyles}>
            {children}
        </span>
    );
};
